import { Box, Spinner, theme } from '@bpba/ui-components';

interface Props {
  size?: string;
  minHeight?: string;
}

export const SuspenseFallback = ({ size = '40px', minHeight = '60vh' }: Props) => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight={minHeight}>
    <Spinner size={size} color={theme.colors.primary[0]} />
  </Box>
);
